import { createSlice } from "@reduxjs/toolkit";
import { groupListDropdownAPI } from "../../services/groupListDropdown";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const groupListDropdownSlice = createSlice({
  name: "groupListDropdown",
  initialState: data,
  reducers: {
    groupListDropdownInfo(state) {
      state.isLoading = true;
    },
    groupListDropdownSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    groupListDropdownFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    groupListDropdownReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const groupListDropdownHandler = (data) => async (dispatch) => {
  try {
    dispatch(groupListDropdownAction.groupListDropdownInfo());
    const response = await groupListDropdownAPI(data);
    dispatch(groupListDropdownAction.groupListDropdownSuccess(response));
  } catch (e) {
    dispatch(groupListDropdownAction.groupListDropdownFailure(e?.response?.data?.message));
  }
};
export default groupListDropdownSlice.reducer;
export const groupListDropdownAction = groupListDropdownSlice.actions;
